export function parseMoney(input: string, allowNegative = false): number | null {
  if (input === '' || input === '-') return null;
  if (!allowNegative && input.startsWith('-')) return null;
  const n = Number(input);
  if (!isFinite(n) || isNaN(n)) return null;
  return n;
}

export function parsePercent(input: string): number | null {
  if (input === '' || input === '-') return null;
  const n = Number(input);
  if (!isFinite(n) || isNaN(n)) return null;
  return n;
}

export function formatMoneyForInput(value: number | null | undefined): string {
  if (value === null || value === undefined) return '';
  return String(value);
}

export function formatPercentForInput(value: number | null | undefined): string {
  if (value === null || value === undefined) return '';
  return String(value);
}

export function isMoneyInputIntermediate(input: string, allowNegative = false): boolean {
  if (allowNegative) return /^-?\d*\.?\d*$/.test(input);
  return /^\d*\.?\d*$/.test(input);
}

export function isPercentInputIntermediate(input: string): boolean {
  return /^-?\d*\.?\d*$/.test(input);
}